import React from 'react';
import styled from 'styled-components';
import { AiFillInfoCircle } from 'react-icons/ai';
import { useScreenQuery } from 'playup-web-core';

import formatCurrency from '../../../utils/formatCurrency';

const DepositLimitHeader = () => {
	const { isSmall } = useScreenQuery();
	const limitItem = React.useMemo(() => {
		const limits = window.portal?.user?.limits();
		let tempLimit = limits?.[0];
		limits?.forEach((item) => {
			if (!tempLimit) tempLimit = item;
			if (item.limit < tempLimit?.limit) {
				tempLimit = item;
			}
		});
		return tempLimit;
	}, []);

	if (!limitItem) return null;

	return (
		<Container isSmallScreen={isSmall}>
			{limitItem && <AiFillInfoCircle name="infocirlce" size={12} style={{ marginRight: 8 }} color="white" />}

			{limitItem && (
				<>
					You’ll be able to deposit up to {formatCurrency(Math.max(limitItem?.limit - limitItem?.used, 0))}{' '}
					{limitItem.duration.name}.
				</>
			)}
		</Container>
	);
};
const Container = styled.div<{ isSmallScreen: boolean }>`
	background-color: #59b059;
	color: #fff;
	height: 40px;
	border-radius: 6px;
	padding-bottom: 10px;
	align-items: center;
	justify-content: center;
	flex-direction: row;
	display: flex;
	font-size: 12px;
	width: ${({ isSmallScreen }) => (!isSmallScreen ? '100%' : 'calc(100% - 24px)')};
	margin: ${({ isSmallScreen }) => (!isSmallScreen ? '0' : '0 12px')};
`;
export default DepositLimitHeader;
